export default {
	props: {
		section: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
        template(){
            let _template = undefined;
            if(this.section.templates && this.section.templates.length){
                _template = this.section.templates.find(template => {
                    return template.selected;
                });
            }
            return _template;
        }
    }
};
